import { Component, ElementRef, forwardRef, Input, ViewChild, HostListener, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface SelectOption {
  label: string;
  value: any;
}

@Component({
  selector: 'sd-select',
  standalone: false,
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ]
})
export class SelectComponent implements ControlValueAccessor {
  @Input() options: SelectOption[] = [];
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() selectedOption: SelectOption | null = null;

  @Output() valueChange = new EventEmitter<any>();
  
  @ViewChild('dropdown') dropdownElement!: ElementRef;
  
  isOpen = false;
    
  toggleDropdown(): void {
    if (this.disabled) return;
    
    this.isOpen = !this.isOpen;
    
    if (this.isOpen) {
      this.ngOnTouched();
    }
  }
  
  selectOption(option: SelectOption, event: Event): void {
    event.stopPropagation();
    
    this.selectedOption = option;
    this.isOpen = false;
    this.ngOnChange(option.value);
    this.valueChange.emit(option.value);
  }
  
  get displayValue(): string {
    return this.selectedOption ? this.selectedOption.label : this.placeholder;
  }
  
  @HostListener('document:click', ['$event'])
  private closeDropdownOnOutsideClick(event: MouseEvent): void {
    if (this.dropdownElement && !this.dropdownElement.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
  // ControlValueAccessor Implementation
  private ngOnChange: (value: any) => void = () => {};
  private ngOnTouched: () => void = () => {};

  writeValue(value: any): void {
    if (value === undefined || value === null) {
      this.selectedOption = null;
      return;
    }
    
    this.selectedOption = this.options.find(option => option.value === value);
  }
  
  registerOnChange(fn: any): void {
    this.ngOnChange = fn;
  }
  
  registerOnTouched(fn: any): void {
    this.ngOnTouched = fn;
  }
  
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
